import React, { useContext, useRef, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./Product.css";
import Marketplace_SinglePrice from "./Marketplace_SinglePrice";
import TopBar from "../TopBar";
import { ProductContext } from "../../Context/products_context";
import Footerr from "../Footerr/Footerr";
import { AuthContext } from "../../Context/AuthContextProvider";
import tuner from "./../../Assets/Media/Frame 3.jpg";
import tuner2 from "./../../Assets/Media/Frame 2.jpg";
import tuner3 from "./../../Assets/Media/Frame 4.jpg";
import tuner4 from "./../../Assets/Media/Frame 5.jpg";
import moment from "moment";
import { AButton } from "../../Assets/Elements";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProgressBar from "./../ProgressBar";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FaShieldAlt, FaSearch, FaTrophy } from "react-icons/fa";
import QuestionsForDetailedPage from "../FAQs/QuestionsForDetailedPage";
import { DataHomeQuestions } from "../FAQs/Data";
import PropTypes from "prop-types";
import { post } from "../../utils/api";

const accordionData = [
  {
    heading: "Recognizable Branding",
    detail:
      "The .gold domain extension is ideal for brands seeking a premium and memorable web presence that reflects excellence and trust.",
  },
  {
    heading: "Industry Authority",
    detail:
      "A .gold domain builds instant credibility, symbolizing prestige and leadership across industries that value luxury and quality.",
  },
  {
    heading: "Targeted Reach",
    detail:
      "Whether in jewelry, investment, or innovation, .gold domains help you connect with your ideal, high-value audience.",
  },
  {
    heading: "SEO Advantage",
    detail:
      "Enhance visibility and ranking for gold-related searches while positioning your brand for premium recognition.",
  },
];

function Marketplace_ProductDetail() {
  const { isAuth, loginUser } = useContext(AuthContext);
  const products = useContext(ProductContext);
  const { productId } = useParams();
  const featureRef = useRef(null);

  const thisProduct = products.find((prod) => prod._id === productId);

  // 👁️ Track view when component mounts or productId changes
  useEffect(() => {
    if (thisProduct?._id) {
      trackView();
    }
  }, [thisProduct?._id]); // Tracks on page load and refresh

  const trackView = async () => {
    try {
      // Track view - counts ALL visits including owner and refreshes
      await post(`/domain/track-view/${thisProduct._id}`, {
        userId: loginUser?._id || null, // null for guest users
      });
    } catch (error) {
      // Don't show error to user - silently fail
    }
  };

  if (!thisProduct) return null;

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 400,
    autoplaySpeed: 4000,
    cssEase: "ease-in-out",
  };

  return (
    <div>
      <ProgressBar />
      <TopBar />

      <div className="FunProductDetail-part">
        <div className="checkout-ProductDetail pattern-bg2">
          <div className="checkout-body-ProductDetail pattern-bg2">
            {/* Left Section */}
            <div className="ProductDetail-left">
              <div className="detailed-explanation-part">
                <div className="content-container pattern-bg2">
                  <h1 className="title text-pent">{thisProduct?.name}</h1>
                  <div className="gradient-line-bar"></div>
                  <p className="paragraph my-[10px]">
                    {thisProduct?.description || ""}
                  </p>

                  {thisProduct?.descriptions?.length > 0 &&
                    thisProduct.descriptions.map((desc, idx) => (
                      <p key={idx} className="paragraph mt-[8px] mb-[12px]">
                        {desc}
                      </p>
                    ))}

                  {/* Domain Tags */}
                  <div className="specialty-chips">
                    <h1>Domain</h1>
                    <h1>Business</h1>
                    {thisProduct?.premium && <h1>Premium</h1>}
                    {thisProduct?.speciality && (
                      <h1>{thisProduct.speciality}</h1>
                    )}
                    {thisProduct?.category && <h1>{thisProduct.category}</h1>}
                  </div>

                  {/* Info */}
                  <div className="specialty-chips-two">
                    <div>
                      <h1 className="heading !text-[grey] !text-[16px]">
                        Domain Registered
                      </h1>
                      <p className="paragraph">
                        {moment(thisProduct?.renewal).format("MMMM D, YYYY")}
                      </p>
                    </div>

                    <div>
                      <h1 className="heading !text-[grey] !text-[16px]">
                        Registrar
                      </h1>
                      <p className="paragraph">{thisProduct?.registrar}</p>
                    </div>
                  </div>

                  {/* Auth Check */}
                  {!isAuth ? (
                    <div className="login-request">
                      <div className="login-request-content">
                        <h1 className="login-request-heading">
                          Please login to view complete details of{" "}
                          {thisProduct?.name}
                        </h1>
                        <br />
                        <Link to="/signup">
                          <AButton>REGISTER FOR FREE</AButton>
                        </Link>
                        <br />
                        <p className="paragraph">
                          Already have an account?{" "}
                          <Link
                            to="/login"
                            className="text-pent border-b-[2px] border-[#5fa8d3]"
                          >
                            Login
                          </Link>
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {/* Why Buy Section */}
                      {thisProduct?.whyToBuyExplanation && (
                        <div>
                          <hr className="gradient-hr" />
                          <h1 className="font-bold text-[#101c4c] !text-[32px] mt-[12px]">
                            Why Own{" "}
                            <span className="text-pent">
                              {thisProduct?.name}
                            </span>
                            ?
                          </h1>
                          <p className="mt-[8px] mb-[12px] paragraph">
                            {thisProduct?.whyToBuyExplanation}
                          </p>
                        </div>
                      )}

                      {thisProduct?.whyToBuy?.length > 0 &&
                        thisProduct.whyToBuy.map((point, idx) => (
                          <ul key={idx}>
                            <li className="list-disc list-inside mt-[12px] ml-[16px]">
                              <h1 className="!font-[700] text-[#101c4c] text-[20px] inline ml-[-8px] mb-[16px]">
                                {point.heading}
                              </h1>
                              <p className="paragraph mt-[4px] mb-[16px] ml-[12px]">
                                {point.explanation}
                              </p>
                            </li>
                          </ul>
                        ))}

                      {/* Why .Gold Section */}
                      <div className="my-[12px]">
                        <hr className="gradient-hr" />
                        <h1 className="font-bold text-[#101c4c] !text-[32px] mt-[12px]">
                          What makes a{" "}
                          <span className="text-pent">.Gold domain</span>{" "}
                          special?
                        </h1>
                        <div className="mt-[16px]">
                          {accordionData.map((item, index) => (
                            <Accordion key={index} className="shadow-md">
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel-content-${index}`}
                                id={`panel-header-${index}`}
                                className="bg-white"
                              >
                                <Typography
                                  sx={{
                                    fontSize: "20px",
                                    fontWeight: "700",
                                    color: "#101c4c",
                                  }}
                                >
                                  {item.heading}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails className="pattern-bg2 p-0">
                                <Typography>
                                  <p className="paragraph px-[16px] py-[12px]">
                                    {item.detail}
                                  </p>
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          ))}
                        </div>
                      </div>

                      {/* Marketplace Features */}
                      <div ref={featureRef} className="mt-[16px]">
                        <hr className="gradient-hr" />
                        <h1 className="font-bold text-[#101c4c] !text-[32px] mt-[24px]">
                          <span className="text-pent">GetBrand.gold</span>{" "}
                          Features
                        </h1>
                        <GoldDomainCards cardsData={cardsData} />
                      </div>

                      {/* FAQs */}
                      <div className="mt-[16px]">
                        <hr className="gradient-hr" />
                        <h1 className="font-bold text-[#101c4c] !text-[32px] mt-[24px] mb-[24px]">
                          Frequently Asked{" "}
                          <span className="text-pent">Questions</span>
                        </h1>
                        <QuestionsForDetailedPage data={DataHomeQuestions} />
                      </div>

                      <Link to="/marketplace-help" className="mt-[16px]">
                        <button className="join-btn custom-btn main-buttonn w-fit">
                          Contact Us
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div className="ProductDetail-right">
              <Slider {...settings}>
                {[tuner, tuner2, tuner3, tuner4].map((img, idx) => (
                  <div key={idx} className="relative">
                    <img src={img} alt="" className="tuner-img" />
                    <p className="detailed-domain-text-on-image">
                      {thisProduct?.name}
                    </p>
                  </div>
                ))}
              </Slider>

              <div>
                <Marketplace_SinglePrice product={thisProduct} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footerr />
    </div>
  );
}

export default Marketplace_ProductDetail;

const cardsData = [
  {
    icon: <FaShieldAlt className="m-auto" />,
    heading: "Trusted Marketplace",
    description:
      "Every domain listed is verified for authenticity and ownership, ensuring secure and transparent transactions.",
  },
  {
    icon: <FaSearch className="m-auto" />,
    heading: "Expert Insights",
    description:
      "Our experts evaluate each domain for branding potential, market relevance, and long-term value.",
  },
  {
    icon: <FaTrophy className="m-auto" />,
    heading: "Premium Selection",
    description:
      "We curate top-tier .gold domains that represent excellence, trust, and digital prestige.",
  },
];

const GoldDomainCards = ({ cardsData }) => {
  GoldDomainCards.propTypes = {
    cardsData: PropTypes.array.isRequired,
  };
  return (
    <div className="row flex-wrap p-[12px] mt-[16px]">
      {cardsData.map((card, index) => (
        <div
          key={index}
          className="col-12 col-md-4 text-center p-[16px] shadow-lg"
        >
          <div>
            <div
              style={{
                fontSize: "40px",
                color: "#b99653",
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              {card.icon}
            </div>
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "10px",
              }}
            >
              {card.heading}
            </h3>
            <p style={{ fontSize: "16px", color: "#555" }}>
              {card.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};